import { render, staticRenderFns } from "./ListAsetKerjasamaPage.vue?vue&type=template&id=10aedcb1"
import script from "./ListAsetKerjasamaPage.vue?vue&type=script&lang=js"
export * from "./ListAsetKerjasamaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports